// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomerList_wrapper__iyFFd","action-button":"CustomerList_action-button__0E1Kf"};